"use strict";

define('components/tabs/tabs',['jquery'], function ($) {
  function changeTab(ev) {
    var el = $(ev.currentTarget);
    el.siblings().removeClass('active');
    el.addClass('active');
    el.trigger('tab-change');
  }
  ;
  $(document).on('click.rs-tabs', "[data-tab]", changeTab).on('init-tab', "[data-tab]", changeTab);
});

